import { getAxios } from './axios'

import {addAuthTokenData} from './member';

export function getMemberBobstoreProductsOwned(params = {}) {
    let axios = getAxios();

    return axios.request({
        url: '/member/bobstore_products_owned/',
        method: 'get',
        params: {...addAuthTokenData(params)}
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/memberBobstoreProductsOwned.js